import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { mergeClassNames } from '../utils/mergeClassNames.es.js';
import React from 'react';
import { Radio as Radio$1 } from 'react-aria-components';

const radio = "_radio_678cl_1";
const styles = {
	radio: radio
};

const Radio = (_a) => {
  var { className } = _a, props = __rest(_a, ["className"]);
  return React.createElement(Radio$1, Object.assign({ className: (renderProps) => mergeClassNames([styles.radio, className], renderProps), "data-zds": true }, props));
};

export { Radio };
//# sourceMappingURL=Radio.es.js.map
